import {
  adjustSize,
  parseSlideData,
  parseSliderConfig,
  startSliderAutoplay,
  switchSlide,
  syncTeasers,
  syncThumbs,
  updateCounter,
} from './slider';

require('owl.carousel');

const SLIDER_ROOT_KEY = 'teaser-slider';
const SLIDER_SLIDE_KEY = 'slide';
const SLIDER_TYPE = 'teaser';
let SLIDER_INDEX = 0;

export default class TeaserSliderComponent {
  init() {
    jQuery(SLIDER_ROOT_KEY).each((i, el) => {
      this.render(el);
    });

    return this;
  }

  /**
   * Renders the Teaser Slider
   * @param {HTMLElement} sliderElement
   */
  render(sliderElement) {
    SLIDER_INDEX = 1 + SLIDER_INDEX;
    const xml = sliderElement.outerHTML;
    const config = parseSliderConfig(sliderElement, SLIDER_TYPE);
    const thumbsId = `thumbs-${SLIDER_INDEX}`;
    const teasersId = `teaser-slider--${SLIDER_INDEX}`;

    const sliderDom = jQuery(`<div class="slider teaser-slider owl-carousel owl-theme" id="${teasersId}" />`);
    const thumbsDom = jQuery(`<div class="thumb-slider owl-carousel owl-theme" id="${thumbsId}"/>`);
    jQuery(xml)
      .children(SLIDER_SLIDE_KEY)
      .each((j, slide) => {
        const data = parseSlideData(slide, SLIDER_TYPE);
        sliderDom.append(`
          <div class="slider__slide">
            <article class="article contextual-region">
              <div class="article__wrap">
                <div class="article__image">
                  <div class="article__loader"></div>
                  <img src="${data.teaserImage.trim()}" alt="${data.teaserTitle}" width="1200" height="675">
                </div>
                <div class="article__text-container ps-1">
                  <header class="article__details"></header>
                  <div class="article__content">
                    <h3 class="article__name">${data.teaserTitle}</h3>
                    <div class="article__body">
                      <p>${data.teaserIntro}</p>
                    </div>
                    <p class="article__more">
                    ${
                      data.teaserLink
                        ? `<a href="${data.teaserLink}" class="primary-link">${data.teaserCTA ? data.teaserCTA : 'Read more'}</a>`
                        : ''
                    }
                      
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        `);

        thumbsDom.append(`
        <button class="slider__slide slider__thumb" style="background-image:url(${data.teaserImage})"></button>
        `);
      });

    const sliderGroup = jQuery(`<div class='carousel__wrapper'></div>`);
    sliderGroup.append(sliderDom, thumbsDom);
    startSliderAutoplay(sliderDom);

    jQuery(sliderElement).replaceWith(sliderGroup);

    jQuery(`#${teasersId}`).on('initialized.owl.carousel', () => {
      adjustSize(teasersId, thumbsId);
    });

    jQuery(`#${teasersId}`).on('changed.owl.carousel', syncTeasers);

    jQuery(`#${teasersId}`).owlCarousel(config);
    updateCounter(jQuery(`#${teasersId} .slider__slide`).length, 1, SLIDER_INDEX);

    jQuery(window).on('resize', function () {
      adjustSize(teasersId, thumbsId);
    });

    const thumbConfig = parseSliderConfig(sliderElement, 'thumbs');
    thumbsDom
      .on('initialized.owl.carousel', () => {
        jQuery(`#${thumbsId}`).find('.owl-item').eq(0).addClass('current');
      })
      .owlCarousel(thumbConfig)
      .on('changed.owl.carousel', syncThumbs);

    jQuery(`#${thumbsId}`).on('click', '.owl-item', switchSlide);
  }
}
